import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

// Utility function to combine class names with Tailwind CSS support
export const cn = (...inputs: ClassValue[]): string => {
  return twMerge(clsx(inputs))
}

// Common CSS classes for consistent styling
export const baseInputStyles = 'w-full px-3 py-2 border rounded-md text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2'

export const inputVariants = {
  default: 'border-gray-300 focus:border-blue-500 focus:ring-blue-500',
  error: 'border-red-500 focus:border-red-500 focus:ring-red-500',
  success: 'border-green-500 focus:border-green-500 focus:ring-green-500',
  disabled: 'bg-gray-50 text-gray-500 cursor-not-allowed'
}

export const labelStyles = 'block text-sm font-medium text-gray-700 mb-1'

export const errorStyles = 'text-sm text-red-600 mt-1'

export const helperTextStyles = 'text-sm text-gray-500 mt-1'

export const buttonStyles = 'inline-flex items-center justify-center px-4 py-2 text-sm font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed'

export const buttonVariants = {
  primary: 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500',
  secondary: 'bg-gray-600 text-white hover:bg-gray-700 focus:ring-gray-500',
  outline: 'border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:ring-blue-500',
  ghost: 'text-gray-700 hover:bg-gray-100 focus:ring-blue-500'
}

export const cardStyles = 'bg-white border border-gray-200 rounded-lg shadow-sm'

export const cardHeaderStyles = 'px-6 py-4 border-b border-gray-200'

export const cardContentStyles = 'px-6 py-4'